import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, r as n } from "./dist-By11B3Nf.js";
import { a as r } from "./dist-7tgynhKG.js";
import { a as i, c as a, i as o, l as s, n as c, o as l, r as u, s as d, t as f } from "./dist-BWsUe_id.js";
import { buttonVariants as p } from "./foundations/button.js";
import "./button-C8zrAH2m.js";
import * as m from "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-alert-dialog@1.1.20_@types+react-dom@19.2.3_@types+react@19.2.17__@type_50d8dbf4835a0ff730b4b08654dec378/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs
var _ = Object.defineProperty, v = (e, t) => _(e, "name", {
	value: t,
	configurable: !0
}), [y, b] = t("AlertDialog", [s]), x = s(), S = /* @__PURE__ */ v((e) => {
	let { __scopeAlertDialog: t, ...n } = e;
	return /* @__PURE__ */ h(f, {
		...x(t),
		...n,
		modal: !0
	});
}, "AlertDialog"), C = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e;
	return /* @__PURE__ */ h(a, {
		...x(n),
		...r,
		ref: t
	});
}, "AlertDialogTrigger")), w = /* @__PURE__ */ v((e) => {
	let { __scopeAlertDialog: t, ...n } = e;
	return /* @__PURE__ */ h(l, {
		...x(t),
		...n
	});
}, "AlertDialogPortal"), T = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e;
	return /* @__PURE__ */ h(i, {
		...x(n),
		...r,
		ref: t
	});
}, "AlertDialogOverlay")), [E, D] = y("AlertDialogContent"), O = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: i, children: a, ...o } = e, s = x(i), c = r(t, m.useRef(null)), l = m.useRef(null);
	return /* @__PURE__ */ h(E, {
		scope: i,
		cancelRef: l,
		children: /* @__PURE__ */ h(u, {
			role: "alertdialog",
			...s,
			...o,
			ref: c,
			onOpenAutoFocus: n(o.onOpenAutoFocus, (e) => {
				e.preventDefault(), l.current?.focus({ preventScroll: !0 });
			}),
			onPointerDownOutside: (e) => e.preventDefault(),
			onInteractOutside: (e) => e.preventDefault(),
			children: a
		})
	});
}, "AlertDialogContent")), k = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e;
	return /* @__PURE__ */ h(d, {
		...x(n),
		...r,
		ref: t
	});
}, "AlertDialogTitle")), A = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e;
	return /* @__PURE__ */ h(o, {
		...x(n),
		...r,
		ref: t
	});
}, "AlertDialogDescription")), j = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e;
	return /* @__PURE__ */ h(c, {
		...x(n),
		...r,
		ref: t
	});
}, "AlertDialogAction")), M = "AlertDialogCancel", N = m.forwardRef(/* @__PURE__ */ v(function(e, t) {
	let { __scopeAlertDialog: n, ...i } = e, { cancelRef: a } = D(M, n), o = x(n), s = r(t, a);
	return /* @__PURE__ */ h(c, {
		...o,
		...i,
		ref: s
	});
}, "AlertDialogCancel")), P = S, F = C, I = w, L = T, R = O, z = j, B = N, V = k, H = A, U = P, W = F, G = I, K = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(L, {
	className: e("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", t),
	...n,
	ref: r
}));
K.displayName = L.displayName;
var q = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g(G, { children: [/* @__PURE__ */ h(K, {}), /* @__PURE__ */ h(R, {
	ref: r,
	className: e("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom-5 data-[state=open]:slide-in-from-bottom-5 sm:rounded-lg", t),
	...n
})] }));
q.displayName = R.displayName;
var J = ({ className: t, ...n }) => /* @__PURE__ */ h("div", {
	className: e("flex flex-col space-y-2 text-center sm:text-left", t),
	...n
});
J.displayName = "AlertDialogHeader";
var Y = ({ className: t, ...n }) => /* @__PURE__ */ h("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
Y.displayName = "AlertDialogFooter";
var X = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(V, {
	ref: r,
	className: e("text-lg font-semibold", t),
	...n
}));
X.displayName = V.displayName;
var Z = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(H, {
	ref: r,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
Z.displayName = H.displayName;
var Q = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(z, {
	ref: r,
	className: e(p(), t),
	...n
}));
Q.displayName = z.displayName;
var $ = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(B, {
	ref: r,
	className: e(p({ variant: "outline" }), "mt-2 sm:mt-0", t),
	...n
}));
$.displayName = B.displayName;
//#endregion
export { Z as a, K as c, W as d, q as i, G as l, Q as n, Y as o, $ as r, J as s, U as t, X as u };

//# sourceMappingURL=alert-dialog-Ca8qCttL.js.map